import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import type { Step } from "@circle-react/types/CommunityInbox/Message";
import { Button } from "@circleco/compass/components/Button";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

const stepLabel = ({ name, arguments: args }: Step) => {
  switch (name) {
    case "query_knowledge_base":
      // Models sometimes quote the query themselves, and the label already quotes it.
      return t("community_inbox.preview_steps.knowledge_search", {
        query: args.query?.replace(/^["“”]+|["“”]+$/g, ""),
      });
    case "hand_off_to_human":
      return t("community_inbox.preview_steps.hand_off", {
        reason: args.reason,
      });
    case "web_search":
      return t("community_inbox.preview_steps.web_search", {
        query: args.query?.replace(/^["“”]+|["“”]+$/g, ""),
      });
    case "web_fetch":
      return t("community_inbox.preview_steps.web_fetch", {
        url: args.url,
      });
    case "search_member_directory":
      if (!args.query?.trim()) {
        return t("community_inbox.preview_steps.member_directory_browse");
      }
      return t("community_inbox.preview_steps.member_directory_search", {
        query: args.query.replace(/^["“”]+|["“”]+$/g, ""),
      });
    case "list_upcoming_events":
      if (!args.query?.trim()) {
        return t("community_inbox.preview_steps.upcoming_events");
      }
      return t("community_inbox.preview_steps.upcoming_events_search", {
        query: args.query.replace(/^["“”]+|["“”]+$/g, ""),
      });
    default:
      return name;
  }
};

export const PreviewSteps = ({ steps }: { steps: Step[] }) => {
  const [isOpen, toggleIsOpen] = useBoolean(false);

  return (
    <div className="flex flex-col items-start gap-2">
      <Button variant="ghost" size="sm" type="button" onClick={toggleIsOpen}>
        {isOpen
          ? t("community_inbox.preview_steps.hide")
          : t("community_inbox.preview_steps.show")}
      </Button>
      {isOpen && (
        <ol className="flex flex-col gap-1">
          {steps.map((step, index) => (
            // eslint-disable-next-line react/no-array-index-key -- a reply's steps never reorder.
            <li key={index}>
              <Typography variant="body-sm" color="secondary">
                {stepLabel(step)}
              </Typography>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
